<template>
  <v-dialog class="mb-4" v-model="dialog" max-width="80vw" height="200%">
    <v-card class="review-popup white pt-4">
      <v-container container-fluid grid-list-xl>
        <v-layout row wrap justify-space-between>
          <v-flex xs12 sm12 md9 lg9 xl9>
            <h4 class="primary--text">{{productName}}</h4>
            <p v-html="details"></p>
            <h3 class="cmx-5">
              <v-rating v-model="totalrating" color="#edb867" readonly></v-rating>
            </h3>
            <h5>{{ratingCount}} {{reviewdata.Reviews_Label}}</h5>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3 xl3 add-later-btn>
            <v-btn
              class="accent"
              large
              @click="dialog = false"
            >{{reviewdata.Add_Later_Button_Label}}</v-btn>
          </v-flex>
        </v-layout>
        <v-divider class="my-6"></v-divider>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg6 xl6>
            <div class="user-list">
              <v-layout row wrap v-for="(review,key) in allComments" :key="key">
                <v-flex xs8 sm8 md8 lg2 xl2>
                  <img class="br-100" src="\static\images\user.svg" width="90" alt="Review user" />
                </v-flex>
                <v-flex xs12 sm12 md12 lg10 xl10>
                  <h6>{{review.keyword1}}</h6>
                  <div class="star">
                    <v-rating
                      v-model="review.number1"
                      color="#edb867"
                      readonly="true"
                      v-bind:size="20"
                    ></v-rating>
                  </div>
                  <span>{{dateFormat(review.date1)}}</span>
                  <p>{{review.text1}}.</p>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md12 lg6 xl6>
            <h4>{{reviewdata.Review_Title}}</h4>
            <form class="example-form">
              {{reviewdata.Your_Rating_Label}}
              <v-rating v-model="rating" color="#edb867"></v-rating>
              <v-text-field :placeholder="reviewdata.Your_Title_Placeholder" v-model="Title"></v-text-field>
              <v-text-field :placeholder="reviewdata.Write_Review_Placeholder" v-model="Review"></v-text-field>
              <v-btn
                class="accent"
                large
                @click="addReview()"
              >{{reviewdata.Post_Review_Button_Label}}</v-btn>
            </form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from "vue";
import gettingRestClientObject from "../../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});
export default {
  props: ["reviewdata", "ProductCode", "productName", "details"],
  data() {
    return {
      cmsRequestFunctions: null,
      rating: 0,
      totalrating: "",
      Title: "",
      Review: "",
      dialog: false,
      allComments: [],
      ratingCount: "",
    };
  },
  methods: {
    /**
     * This function opens the popup
     **/
    open() {
      this.dialog = true;
    },
    /**
     * This function close the popup
     **/
    close() {
      this.dialog = false;
    },
    addReview: async function () {
      var self = this;
      if (self.checkSignInOrNot()) {
        if (!self.rating) {
          this.$snotify.warning(
            self.cmsRequestFunctions.getValidationMsgByCode("M001"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          return false;
        }
        if (!self.Title) {
          this.$snotify.warning(
            self.cmsRequestFunctions.getValidationMsgByCode("M002"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          return false;
        } else if (!self.Review) {
          this.$snotify.warning(
            self.cmsRequestFunctions.getValidationMsgByCode("M003"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          return false;
        } else {
          let requestedDate = moment(String(new Date())).format(
            "YYYY-MM-DDThh:mm:ss"
          );
          var user = localStorage.getItem("embryo");
          var userData = JSON.parse(user);
          var loginDetails = userData.user_data;
          let insertReview = {
            type: "Review",
            keyword1: loginDetails.name,
            keyword2: this.productName,
            keyword3: this.Title,
            keyword4: this.ProductCode,
            number1: this.rating,
            text1: this.Review,
            date1: requestedDate,
          };
          var Success = await self.cmsRequestFunctions.cmsFormData(
            insertReview
          );
          try {
            let insertID = await Success;
            console.log(insertID);
            self.rating = "";
            self.Title = "";
            self.Review = "";
            this.$snotify.success(
              self.cmsRequestFunctions.getValidationMsgByCode("M004"),
              {
                closeOnClick: false,
                pauseOnHover: false,
                timeout: 1000,
                showProgressBar: false,
              }
            );
            setTimeout(function () {
              self.readReview();
            }, 500);
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    readReview: async function () {
      var self = this;
      self.allComments = [];
      var filterValue = "type='Review' AND keyword4='" + self.ProductCode + "'";
      var allData = await this.cmsRequestFunctions.getDbDataTableValue(
        filterValue,
        "date1"
      );
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        self.allComments = allData.data.data;
        if (self.allComments !== undefined && self.allComments.length > 0) {
          var count = 0;
          for (const element of self.allComments) {
            count = count + element.number1;
          }
          self.totalrating = count / self.allComments.length;
        }
      } else {
        console.log("error:", allData);
      }
      self.ratingCount = self.allComments.length;
    },
    dateFormat(date) {
      if (date) {
        return moment(String(date)).format("DD MMM YYYY");
      }
    },
    checkSignInOrNot() {
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    setTimeout(() => {
      this.readReview();
    }, 500);
  },
};
</script>